import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [


  {
    path: "/admin/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },



  {
    path: "/admin/job-details/applicant-profile",
    title: "Profile",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },


  {
    path: "/admin/job-details/applicant-documents",
    title: "Documents",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  {
    path: "/admin/job-details/all-job-openings",
    title: "Job Openings",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/admin/job-details/all-job-applications",
    title: "Job Applications",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

];
